<template>
    <div class="loginframe">
        <div class="loginhead">
            <div style="margin-left:32px">
                登录
            </div>
        </div>
        <el-form ref="form" :model="form" label-width="80px" class="loginform" @submit.native.prevent>
            <el-form-item label="用户名">
                <el-input v-model="form.name" :maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="密码">
                <el-input v-model="form.pwd" :maxlength="20" show-password></el-input>
            </el-form-item>
        </el-form>
        <div style="text-align:center">
        <el-button type="primary" @click="dologin()"  >登录</el-button>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import {restbase} from '../rest'
    import {foowwLocalStorage} from '../rest'
    export default {
        name: 'login',
        data() {
            return {
                form: {
                    name: '',
                    pwd: ''
                }
            }
        },
		methods: {
			//登录
            dologin(type) {
                var passValite=/^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])).{5,10}$/;
                
                console.log(this.form.pwd);
                 if(!passValite.test(this.form.pwd)){
                      this.$notify.error({
                            title: '错误',
                            message: '密码格式不合法，请去CRM修改密码，密码规则为：必须包含大写字母、小写字母和数字,长度5-10位'
                        });
                        return;
                } 
                this.$http.post(restbase() + "asp/GetAdminInfo", {
                    name: this.form.name,
                    pwd: this.form.pwd
                }).then((response) => {
                    const r = JSON.parse(response.data.d);
                    if (r.code !== '0') {
                        this.$notify.error({
                            title: '错误',
                            message: r.description
                        });
                    } else {
                        //后台管理员
                        //this.$root.admin = r;
                        this.form.name=this.form.name.toLowerCase();
                        foowwLocalStorage.set('admin',JSON.stringify(r));
                        this.$router.push('YBMember');
                    }
                }, (response) => {
                    console.log(response);
                }).catch((response) => {
                    console.log(response);
                });
            }
            
		}
    }
    
</script>

<style>
    .loginframe {
        position: relative;
        height: 370px;
        width:100%;
        margin:0 auto;
        border-radius: 4px;
        border-left: 1px solid #ddd;
        box-shadow: 3px 3px 3px #aaa;
        background-color: white;
    }
    .loginhead {
        width:100%;
        height:48px;
        line-height:48px;
        padding:0;
        color:white;
        background-color:#80A0D0;
        border-radius:4px 4px 0 0;
    }
    .loginform {
        padding: 30px 70px 10px 30px;
    }
</style>